import React, { useState } from 'react';
import '../styles/Products.css';

const Products = () => {
    const [activeCategory, setActiveCategory] = useState('all');
    const [showContactModal, setShowContactModal] = useState(false);
    const [downloadStatus, setDownloadStatus] = useState('');

    // Download files for each product category
    const downloadFiles = [
        {
            name: 'Two-Wheeler Oils TDS',
            file: '/documents/MapLube_TDS_Two_Wheeler_Oils.txt',
            size: '2.1 KB',
            type: 'Technical Data Sheet',
            category: 'two-wheeler'
        },
        {
            name: 'Car Engine Oils TDS',
            file: '/documents/MapLube_TDS_Car_Engine_Oils.txt',
            size: '2.3 KB',
            type: 'Technical Data Sheet',
            category: 'car'
        },
        {
            name: 'Commercial Vehicle Oils TDS',
            file: '/documents/MapLube_TDS_Commercial_Vehicle_Oils.txt',
            size: '2.2 KB',
            type: 'Technical Data Sheet',
            category: 'commercial'
        },
        {
            name: 'Agricultural Oils TDS',
            file: '/documents/MapLube_TDS_Agricultural_Oils.txt',
            size: '2.1 KB',
            type: 'Technical Data Sheet',
            category: 'agricultural'
        },
        {
            name: 'Industrial Lubricants TDS',
            file: '/documents/MapLube_TDS_Industrial_Lubricants.txt',
            size: '2.2 KB',
            type: 'Technical Data Sheet',
            category: 'industrial'
        }
    ];

    // Contact sales information
    const contactSales = {
        phone: '+91-95400-71804',
        email: 'sales@maplube.in',
        whatsapp: '+91-95400-71804',
        address: '10130A, 10th Floor, Gaur City Mall Sector 4, Greater Noida-201318',
        workingHours: 'Monday - Friday: 9:00 AM - 6:00 PM, Saturday: 9:00 AM - 1:00 PM',
        departments: [
            {
                name: 'Two-Wheeler Sales',
                contact: 'Mr. Rajesh Kumar',
                phone: '+91-98765-43211',
                email: 'two-wheeler@maplube.com'
            },
            {
                name: 'Automotive Sales',
                contact: 'Ms. Priya Sharma',
                phone: '+91-98765-43212',
                email: 'automotive@maplube.com'
            },
            {
                name: 'Commercial Vehicle Sales',
                contact: 'Mr. Amit Patel',
                phone: '+91-98765-43213',
                email: 'commercial@maplube.com'
            },
            {
                name: 'Agricultural Sales',
                contact: 'Mr. Suresh Singh',
                phone: '+91-98765-43214',
                email: 'agricultural@maplube.com'
            },
            {
                name: 'Industrial Sales',
                contact: 'Mr. Deepak Verma',
                phone: '+91-98765-43215',
                email: 'industrial@maplube.com'
            }
        ]
    };

    // Function to get download file for a specific category
    const getDownloadFile = (category) => {
        if (category === 'all') {
            return downloadFiles[0]; // Return first file for "all" category
        }
        return downloadFiles.find(file => file.category === category) || downloadFiles[0];
    };

    // Function to handle download
    const handleDownload = (category) => {
        const file = getDownloadFile(category);
        setDownloadStatus(`Downloading ${file.name}...`);

        const link = document.createElement('a');
        link.href = file.file;
        link.download = file.name.replace(/\s+/g, '_') + '.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Show success message briefly
        setTimeout(() => {
            setDownloadStatus(`${file.name} downloaded successfully!`);
            setTimeout(() => setDownloadStatus(''), 3000);
        }, 1000);
    };

    // Function to handle contact sales
    const handleContactSales = () => {
        setShowContactModal(true);
    };

    // Function to close contact modal
    const closeContactModal = () => {
        setShowContactModal(false);
    };

    const productCategories = [
        {
            id: 'two-wheeler',
            name: 'Two-Wheeler Oils',
            icon: '🏍️',
            description: 'Premium engine oils for motorcycles and scooters'
        },
        {
            id: 'car',
            name: 'Car Engine Oils',
            icon: '🚗',
            description: 'High-performance lubricants for passenger vehicles'
        },
        {
            id: 'commercial',
            name: 'Commercial Vehicle Oils',
            icon: '🚛',
            description: 'Heavy-duty oils for trucks and buses'
        },
        {
            id: 'agricultural',
            name: 'Agricultural Oils',
            icon: '🚜',
            description: 'Specialized oils for tractors and farm equipment'
        },
        {
            id: 'industrial',
            name: 'Industrial Lubricants',
            icon: '🏭',
            description: 'Lubricants for industrial machinery and equipment'
        }
    ];

    const products = {
        'two-wheeler': [

            {
                name: 'Maplube Engine Oil Additive 50ml',
                viscosity: 'Not Applicable (Additive)',
                api: 'Not Applicable (Additive)',
                description: 'Engine oil additive that improves engine lubrication, reduces friction, and ensures seamless power transmission.',
                features: [
                    'Effective engine lubrication',
                    'Anti-friction protection',
                    'Enhances engine efficiency',
                    'Seamless power transmission',
                    'Compatible with petrol & diesel engines'
                ],
                packaging: ['50ml'],
                image: '/logo/maplube_additive.jpeg'
            },



            {
                name: 'MapLube 2T Premium',
                viscosity: '2T',
                api: 'TC-W3',
                description: 'High-performance 2-stroke engine oil for motorcycles and scooters',
                features: ['Excellent lubrication', 'Reduces engine wear', 'Clean burning', 'Low smoke emission'],
                packaging: ['1L', '5L'],
                image: '/logo/engine_oil.jpeg'
            },
            {
                name: 'MapLube 4T Supreme',
                viscosity: '10W-30, 20W-50',
                api: 'SN',
                description: 'Advanced 4-stroke engine oil for modern motorcycles',
                features: ['Enhanced engine protection', 'Improved fuel efficiency', 'Extended drain intervals', 'Thermal stability'],
                packaging: ['1L', '5L'],
                image: '/logo/product.jpeg'
            }
        ],
        'car': [
            {
                name: 'MapLube Car Premium',
                viscosity: '5W-30, 10W-40, 20W-50',
                api: 'SN Plus',
                description: 'Full synthetic engine oil for modern passenger vehicles',
                features: ['Superior engine protection', 'Fuel economy improvement', 'Extended oil life', 'Cold start protection'],
                packaging: ['1L', '5L', '20L'],
                image: '/logo/engine_oil.jpeg'
            },
            {
                name: 'MapLube Car Semi-Synthetic',
                viscosity: '10W-30, 15W-40',
                api: 'SN',
                description: 'Semi-synthetic engine oil for balanced performance and value',
                features: ['Good engine protection', 'Cost-effective', 'Wide temperature range', 'Compatible with most engines'],
                packaging: ['1L', '5L', '20L'],
                image: '/logo/product.jpeg'
            },
            {
                name: 'MapLube Car Mineral',
                viscosity: '20W-50',
                api: 'SM',
                description: 'Conventional mineral oil for older vehicles',
                features: ['Reliable protection', 'Affordable price', 'Wide compatibility', 'Proven performance'],
                packaging: ['1L', '5L', '20L'],
                image: '/logo/map.jpeg'
            }
        ],
        'commercial': [
            {
                name: 'MapLube Truck Heavy Duty',
                viscosity: '15W-40, 20W-50',
                api: 'CI-4 Plus',
                description: 'Heavy-duty engine oil for commercial trucks and buses',
                features: ['Extended drain intervals', 'Soot handling', 'High temperature stability', 'Engine protection'],
                packaging: ['5L', '20L', '210L'],
                image: '/logo/map.jpeg'
            },
            {
                name: 'MapLube Bus Premium',
                viscosity: '15W-40',
                api: 'CI-4',
                description: 'Specialized oil for bus engines with frequent stop-start cycles',
                features: ['Stop-start protection', 'Fuel efficiency', 'Extended service life', 'Reduced maintenance'],
                packaging: ['5L', '20L', '210L'],
                image: '/logo/map1.jpeg'
            }
        ],
        'agricultural': [
            {
                name: 'MapLube Tractor Supreme',
                viscosity: '15W-40, 20W-50',
                api: 'CF-4',
                description: 'Heavy-duty engine oil for agricultural tractors and equipment',
                features: ['Dust resistance', 'High load capacity', 'Extended intervals', 'Agricultural conditions'],
                packaging: ['5L', '20L', '210L'],
                image: '/logo/engine_oil.jpeg'
            },
            {
                name: 'MapLube Harvester Oil',
                viscosity: '15W-40',
                api: 'CF-4',
                description: 'Specialized oil for harvesting equipment and agricultural machinery',
                features: ['Seasonal operation', 'High performance', 'Equipment protection', 'Reliable operation'],
                packaging: ['5L', '20L', '210L'],
                image: '/logo/product.jpeg'
            }
        ],
        'industrial': [
            {
                name: 'MapLube Industrial Gear Oil',
                viscosity: 'ISO 220, 320, 460',
                description: 'High-performance gear oil for industrial applications',
                features: ['Extreme pressure protection', 'Thermal stability', 'Corrosion resistance', 'Long service life'],
                packaging: ['5L', '20L', '210L'],
                image: '/logo/map1.jpeg'
            },
            {
                name: 'MapLube Hydraulic Oil',
                viscosity: 'ISO 32, 46, 68',
                description: 'Premium hydraulic oil for industrial machinery',
                features: ['Anti-wear protection', 'Oxidation stability', 'Water separation', 'Foam resistance'],
                packaging: ['5L', '20L', '210L'],
                image: '/logo/map.jpeg'
            }
        ]
    };

    const getFilteredProducts = () => {
        if (activeCategory === 'all') {
            return Object.values(products).flat();
        }
        return products[activeCategory] || [];
    };

    return (
        <div className="products">
            {/* Hero Section */}
            <section className="products-hero">
                <div className="container">
                    <div className="products-hero-content">
                        <h1>Our Products</h1>
                        <p>Comprehensive range of high-quality lubricants for every application</p>
                    </div>
                </div>
            </section>

            {/* Category Filter */}
            <section className="category-filter">
                <div className="container">
                    <div className="filter-buttons">
                        <button
                            className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
                            onClick={() => setActiveCategory('all')}
                        >
                            All Products
                        </button>
                        {productCategories.map(category => (
                            <button
                                key={category.id}
                                className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
                                onClick={() => setActiveCategory(category.id)}
                            >
                                <span className="category-icon">{category.icon}</span>
                                {category.name}
                            </button>
                        ))}
                    </div>
                    {downloadStatus && (
                        <div className="download-status">
                            <span className="status-icon">📥</span>
                            {downloadStatus}
                        </div>
                    )}
                </div>
            </section>

            {/* Products Grid */}
            <section className="products-grid">
                <div className="container">
                    <div className="products-list">
                        {getFilteredProducts().map((product, index) => (
                            <div key={index} className="product-card">
                                <div className="product-image">
                                    <img src={product.image} alt={product.name} />
                                </div>
                                <div className="product-content">
                                    <h3>{product.name}</h3>
                                    <div className="product-specs">
                                        {product.viscosity && (
                                            <div className="spec">
                                                <span className="spec-label">Viscosity:</span>
                                                <span className="spec-value">{product.viscosity}</span>
                                            </div>
                                        )}
                                        {product.api && (
                                            <div className="spec">
                                                <span className="spec-label">API Rating:</span>
                                                <span className="spec-value">{product.api}</span>
                                            </div>
                                        )}
                                    </div>
                                    <p className="product-description">{product.description}</p>
                                    <div className="product-features">
                                        <h4>Key Features:</h4>
                                        <ul>
                                            {product.features.map((feature, idx) => (
                                                <li key={idx}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="product-packaging">
                                        <h4>Available in:</h4>
                                        <div className="packaging-options">
                                            {product.packaging.map((size, idx) => (
                                                <span key={idx} className="packaging-size">{size}</span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="product-actions">
                                        <button className="btn btn-primary" onClick={() => handleDownload(activeCategory)}>Download TDS</button>
                                        <button className="btn btn-outline" onClick={handleContactSales}>Contact Sales</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Product Benefits */}
            <section className="product-benefits">
                <div className="container">
                    <h2>Why Choose MapLube Products?</h2>
                    <div className="benefits-grid">
                        <div className="benefit">
                            <div className="benefit-icon">🛡️</div>
                            <h3>Quality Assurance</h3>
                            <p>Every product undergoes rigorous testing to meet international standards</p>
                        </div>
                        <div className="benefit">
                            <div className="benefit-icon">⚡</div>
                            <h3>Performance</h3>
                            <p>Engineered for maximum efficiency and engine protection</p>
                        </div>
                        <div className="benefit">
                            <div className="benefit-icon">🌱</div>
                            <h3>Environmentally Friendly</h3>
                            <p>Formulated with eco-friendly additives and sustainable practices</p>
                        </div>
                        <div className="benefit">
                            <div className="benefit-icon">🔧</div>
                            <h3>Technical Support</h3>
                            <p>Expert technical support and application guidance</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technical Support */}
            <section className="technical-support">
                <div className="container">
                    <div className="support-content">
                        <div className="support-text">
                            <h2>Technical Support</h2>
                            <p>Our team of lubrication experts is here to help you choose the right product for your application. We provide:</p>
                            <ul>
                                <li>Product selection guidance</li>
                                <li>Technical specifications</li>
                                <li>Application support</li>
                                <li>Training and education</li>
                                <li>Field service support</li>
                            </ul>
                            <button className="btn btn-primary">Contact Technical Team</button>
                        </div>
                        <div className="support-image">
                            <img src="/logo/original_logo.jpeg" alt="Technical Support" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Sales Modal */}
            {showContactModal && (
                <div className="modal-overlay" onClick={closeContactModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Contact Sales</h2>
                            <button className="modal-close" onClick={closeContactModal}>×</button>
                        </div>
                        <div className="modal-body">
                            <p>For more information or to place an order, please contact our sales team:</p>
                            <div className="contact-info">
                                <div className="contact-item">
                                    <span className="contact-icon">📞</span>
                                    <div>
                                        <strong>Phone:</strong> {contactSales.phone}
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-icon">✉️</span>
                                    <div>
                                        <strong>Email:</strong> {contactSales.email}
                                    </div>
                                </div>
                                {/* <div className="contact-item">
                                    <span className="contact-icon">💬</span>
                                    <div>
                                        <strong>WhatsApp:</strong> {contactSales.whatsapp}
                                    </div>
                                </div> */}
                                <div className="contact-item">
                                    <span className="contact-icon">📍</span>
                                    <div>
                                        <strong>Address:</strong> {contactSales.address}
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-icon">🕒</span>
                                    <div>
                                        <strong>Working Hours:</strong> {contactSales.workingHours}
                                    </div>
                                </div>
                            </div>

                            {/* <h3>Department Contacts:</h3>
                            <div className="departments-grid">
                                {contactSales.departments.map((dept, idx) => (
                                    <div key={idx} className="department-card">
                                        <h4>{dept.name}</h4>
                                        <div className="dept-contact">
                                            <p><strong>Contact:</strong> {dept.contact}</p>
                                            <p><strong>Phone:</strong> {dept.phone}</p>
                                            <p><strong>Email:</strong> {dept.email}</p>
                                        </div>
                                    </div>
                                ))}
                            </div> */}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={closeContactModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Products;
